export const getSHA256Hash = async text => {
  if (!text) return '';
  const textAsBuffer = new TextEncoder().encode(text);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash = hashArray
    .map(item => item.toString(16).padStart(2, '0'))
    .join('');
  return hash;
};
